import Question from "./question.js"
import { QUESTION_TYPE_MAP } from "../models.js";
import MultipartQuestionComponent from "../components/questions/multipart-question.jsx";
import MultipartReportComponent from "../components/reports/multipart-report.jsx";

export default class MultipartQuestion extends Question {
    constructor(item) {
        super(item);
        /**
         * @type {Question[]}
         */
        this.parts = (this.responseDeclaration.parts || []).map(part => {
            let response_type = part.response_type;
            let id = part.id;
            let assessmentItem = this.included.find((i) => {
                return i.type == "assessment_items" && i.relationships.question_version && i.relationships.question_version.data && Number(i.relationships.question_version.data.id) == part.id
            })
            let assessmentItemId = assessmentItem ? assessmentItem.id : null

            let partJson = {
                data: {
                    id: id,
                    attributes: {...part, assessment_item_id: assessmentItemId}
                }
            }

            return new QUESTION_TYPE_MAP[response_type](partJson);
        });
    }

    component(mode) {
        switch(mode) {
            case "student-facing-report":
                return MultipartReportComponent;
            case "preview":
                return MultipartReportComponent;
            default:
                return MultipartQuestionComponent;
        }
    }
}